<!-- 用户管理 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-button type="primary" size="small" @click="handleAdd" style="margin: 0 20px 0 0">录入</el-button>
      <el-form-item label="检测标题: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.title" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="手机号: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="会话ID: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.answerNumber" placeholder="请输入" clearable></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="创建日期: " style="margin:0 20px 0 0" size="small">
        <el-input v-model="listQuery.create_time" placeholder="请输入" clearable></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="状态:" style="margin: 0px 20px 0 0" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>-->

      <el-button type="primary" @click="search" size="small" style="margin: 0 0px 10 0">搜索</el-button>
      <el-button
        class="addBtn"
        type="primary"
        size="small"
        style="margin-right: 20px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >
        导出 Excel（数量/ {{ tableData.length
        }}条）
      </el-button>
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="phone" slot-scope="{ row }">
          <!-- <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>-->
          {{row.phone?row.phone:'暂无'}}
        </template>
        <template slot="imgUrl" slot-scope="{ row }">
          <el-image
            v-if="row.imgUrl"
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>
          <span v-else>暂无</span>
        </template>
        <template slot="message" slot-scope="{ row }">
          <!-- <el-image
            style="width: 60px; max-height: 60px"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
          ></el-image>-->
          {{row.message?'档案已保存':'暂无数据'}}
        </template>

        <template slot="answerNumber" slot-scope="{ row }">{{row.answerNumber?row.answerNumber:'-'}}</template>

        <!-- <template slot="messgae" slot-scope="{ row }">{{row.message ? row.message : '暂无数据'}}</template> -->

        <template slot="source" slot-scope="{ row }">
          <el-tag
            type="success"
            effect="dark"
            size="mini"
            v-if="row.source == '手动录入'"
          >{{row.source}}</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>{{row.source}}</el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <!-- <el-button size="mini" type="text" @click="handleEdit(row)" primary>查看问答会话</el-button> -->
            <el-button size="mini" type="text" @click="handleRead(row)" primary>预览检测数据</el-button>
            <el-button size="mini" type="text" @click="handleEdit(row)" primary>检测数据修正</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 表单弹窗 -->
    <el-dialog
      :title="dialogName"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="1200px"
    >
      <el-form
        ref="form"
        :model="dialogForm"
        label-width="120px"
        style="max-height: 550px; overflow-y: auto;"
      >
        <el-form-item label="检测标题" required>
          <el-input clearable v-model="dialogForm.title" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="患者openid">
          <el-input clearable v-model="dialogForm.openid" placeholder="聚焦当前输入框，使用扫码枪扫描患者二维码可快速录入"></el-input>
        </el-form-item>
        <el-form-item label="患者手机号">
          <el-input clearable v-model="dialogForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="检测数据档案:">
          <el-input
            clearable
            v-model="dialogForm.message"
            placeholder="请输入检测数据描述文字"
            type="textarea"
            :rows="3"
          ></el-input>
        </el-form-item>-->
        <el-form-item label="检测参数" required>
          <div v-for="(item, index) in dialogForm.message" :key="index" style="display: flex;">
            <el-tag type="success" size="mini" style="margin: 10px">字段中文描述:</el-tag>
            <el-input
              size="mini"
              v-model="item.keyName"
              placeholder="请输入"
              style="width: 100px; margin-right: 10px; margin-top: 5px"
            ></el-input>

            <el-tag type="success" size="mini" style="margin: 10px">字段英文命名:</el-tag>
            <el-input
              size="mini"
              v-model="item.key"
              placeholder="请输入"
              style="width: 100px; margin-right: 10px; margin-top: 5px"
            ></el-input>

            <el-tag type="success" size="mini" style="margin: 10px">字段值:</el-tag>
            <el-input
              size="mini"
              v-model="item.value"
              placeholder="请输入"
              style="width: 450px; margin-right: 10px; margin-top: 10px"
              type="textarea"
              :rows="3"
            ></el-input>
            <el-button
              class="cancelBtn"
              type="text"
              @click="handleDeleteItem(index)"
              style="margin-right: 10px; margin-top: 10px;color:red"
            >删除</el-button>
          </div>
          <el-button
            class="addBtn"
            type="primary"
            @click="handleAddItem"
            style="margin-top: 10px"
            size="mini"
          >+ 添加</el-button>
          <!-- <div class="note">问答ai会按照此步骤进行提问</div> -->
        </el-form-item>
        <!-- 检测图片 -->
        <el-form-item label="检测图片">
          <el-input clearable v-model="dialogForm.imgUrl" placeholder="上传后自动获取图片链接"></el-input>
          <el-upload
            class="upload-demo"
            :action="action"
            :multiple="false"
            :on-success="handleSuccess"
            :file-list="fileList"
            list-type="picture"
            name="formData"
            :limit="1"
          >
            <el-button size="small" type="primary">上传</el-button>
            <div slot="tip" class="el-upload__tip">上传后自动覆盖之前的图,只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 表单弹窗 -->
    <el-dialog title :visible.sync="dialogVisible_read" :close-on-click-modal="false" width="800px">
      <div style="height:1000px" class="dialogForm_read">
        <div
          v-for="(item, index) in dialogForm_read.message"
          :key="index"
          class="dialogForm_read_item"
        >
          <!-- <el-tag type="success" size="mini" style="margin: 10px">{{item.keyName}}</el-tag> -->
          <span style="width: 100px; margin:0 10px;">{{item.keyName}}</span>
          <span style="width: 600px; margin-right: 10px;">{{item.value}}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { selectApi, deleteApi, addApi } from "@/services/niaojian/handResult";
import { IP } from "@/services/index.js";
export default {
  components: {
    ElTable
  },
  created() {
    this.getListData();
  },
  data() {
    return {
      action: IP + "/uploadFile/add",
      downloadLoading: false,
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: ""
      },
      stateList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},

      dialogVisible_read: false,
      dialogForm_read: {},

      statusList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    listHeader,
    ...mapState(["supUser"])
  },

  watch: {},
  methods: {
    async getListData(listQuery) {
      this.loading = true;
      const { data, code, count } = await selectApi(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建检测数据";
      this.dialogForm = {
        message: []
      };
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑检测数据";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      try {
        this.dialogForm.message = row.message ? JSON.parse(row.message) : [];
      } catch (error) {
        this.dialogForm.message = [];
      }
    },

    /* 查看 */
    handleRead(row) {
      this.dialogVisible_read = true;
      this.dialogForm_read = JSON.parse(JSON.stringify(row));
      try {
        this.dialogForm_read.message = row.message
          ? JSON.parse(row.message)
          : [];
      } catch (error) {
        this.dialogForm_read.message = [];
      }
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.imgUrl = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    save() {
      if (!this.dialogForm.openid && !this.dialogForm.phone) {
        this.$message.error("openid 或 手机号 必须录入一项");
        return;
      }
      if (!this.dialogForm.title) {
        this.$message.error("请填写必填字段");
        return;
      }
      console.log(this.dialogForm.message);
      if (this.dialogName === "创建检测数据") {
        addApi({
          ...this.dialogForm,
          source: "手动录入",
          message: JSON.stringify(this.dialogForm.message),
          admin_id: this.supUser.supplier_phone
        }).then(res => {
          console.log("创建检测数据", res);
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑检测数据") {
        addApi({
          ...this.dialogForm,
          message: JSON.stringify(this.dialogForm.message)
        }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该检测数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id);
          deleteApi({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ID",
          "检测标题",
          "用户小程序openid",
          "用户手机号",
          "检测数据",
          "创建时间"
        ];
        const filterVal = [
          "id",
          "title",
          "openid",
          "phone",
          "message",
          "createTime"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "患者检测数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },

    handleAddItem() {
      console.log("this.dialogForm.message", this.dialogForm.message);
      this.dialogForm.message.push({
        keyName: "",
        key: "",
        value: ""
      });
    },

    handleDeleteItem(index) {
      this.dialogForm.message.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  padding: 20px;
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}

.dialogForm_read {
  border: 1px dotted #000000;
}
.dialogForm_read_item {
  display: flex;
  margin: 20px auto;
  width: 95%;
  background: #f2f2f2;
  padding: 10px 0;
}
.dialogForm_read_item > span:first-child {
  font-weight: 550;
}
</style>
